module.exports = __webpack_public_path__ + "static/img/zongji_bg.62d1e0a0.png";